// inspired by https://stackoverflow.com/a/58033583/379279
export function initializeMinCollectionLengthValidation() {
    const validationName = "mincollectionlength";
    $.validator.addMethod(validationName, (value, element, params) => {
        var minCollectionLength = params.min;
        if (!minCollectionLength) return false;

        var collection = $.parseJSON(value);

        return collection.length >= minCollectionLength;
    });

    $.validator.unobtrusive.adapters.add(validationName, ['min'],
        options => {
            options.rules[validationName] = {
                min: options.params['min']
            };
            options.messages[validationName] = options.message;
        });
}

// https://github.com/jwaliszko/ExpressiveAnnotations#how-to-cope-with-values-of-custom-types
export function initializeExpressiveAnnotationsCustomTypeHandling() {
    // @ts-ignore
    window.ea.addValueParser("iformfile", (value, field) => value);
    // @ts-ignore
    window.ea.addValueParser("enumeration", (value, field) => value);
}
